import { useState } from "react";
import { toast } from "sonner";
import { MailCheck, Loader2 } from "lucide-react";
import api, { errMsg } from "@/lib/api";

// Shown while the account's email is unverified: enter the emailed code, or ask for a new one.
export default function VerifyEmailBanner({ email, onVerified }) {
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/verify-email", { code: code.trim() });
      toast.success("Το email επαληθεύτηκε.");
      onVerified();
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  const resend = async () => {
    try { await api.post("/auth/resend-verification"); toast.success("Στάλθηκε νέος κωδικός."); }
    catch (err) { toast.error(errMsg(err)); }
  };

  return (
    <form onSubmit={submit} data-testid="verify-email-banner"
      className="mb-6 rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3 flex flex-wrap items-center gap-3 text-sm text-amber-900">
      <MailCheck className="w-4 h-4 shrink-0" />
      <span className="flex-1 min-w-[12rem]">Επαληθεύστε το email σας ({email}) με τον κωδικό που σας στείλαμε.</span>
      <input data-testid="verify-email-code" inputMode="numeric" maxLength={10} required placeholder="Κωδικός"
        value={code} onChange={(e) => setCode(e.target.value)} className="field w-32 px-3 py-2 text-sm" />
      <button data-testid="verify-email-submit" disabled={busy || code.trim().length < 4} className="btn-primary px-4 py-2 text-sm flex items-center gap-2">
        {busy && <Loader2 className="w-4 h-4 animate-spin" />}Επαλήθευση
      </button>
      <button type="button" data-testid="verify-email-resend" onClick={resend} className="btn-ghost px-3 py-2 text-sm">Νέος κωδικός</button>
    </form>
  );
}
